import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import { setupInterceptor } from "./interceptors/axios";

import ElementPlus from "element-plus";
import ptBR from "element-plus/es/locale/lang/pt-br";
import "element-plus/dist/index.css";

import VCalendar from "v-calendar";
import "v-calendar/style.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/assets/css/fonts.css";

library.add(fas);

const app = createApp(App);
app.use(router);
app.use(ElementPlus, { locale: ptBR });
app.use(VCalendar, {});
app.component("font-awesome-icon", FontAwesomeIcon);

setupInterceptor();

router.isReady().then(() => {
  app.mount("#app");
});
